import { z } from "zod";

/** Represents the enum public.notification_status */
type NotificationStatus =
  | "pending"
  | "sent"
  | "failed"
  | "schema_validation_failed"
  | "adapter_error";

export default NotificationStatus;

/** Zod schema for notification_status */
export const notificationStatus = z.enum([
  "pending",
  "sent",
  "failed",
  "schema_validation_failed",
  "adapter_error",
]);
